import APIService from '@/services/APIService';

export default {
  searchByTime(data) {
    return APIService.post('/schedules/search-this-time', data);
  },
  index(params) {
    return APIService.get('/schedules', { params });
  },
  show(id, params) {
    return APIService.get(`/schedules/${id}`, { params });
  },
  create(data, obs) {
    return APIService.post('/schedules', data, { rOptions: { obs } });
  },
  update(id, data) {
    return APIService.put(`/schedules/${id}`, data);
  },
  delete(id) {
    return APIService.delete(`/schedules/${id}`);
  },
};
